const AppStyle = theme => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        width: '100vw',
        minHeight: '100vh'
    },
})
export default AppStyle;